import { ReactElement } from 'react';

import styles from './SpecialistPersonBlackCard.module.scss';
import {
  PreviewImage,
  Slots,
  SpecialisationInfo,
  SpecialistNavigate,
} from '../../../3_features';
import { Link, useNavigate } from 'react-router-dom';
import { Typography } from '../../../1_shared/ui';
import { InfoSpecialist } from '../../../2_entities';
import { useAuthContext } from '../../../app/module/lib/hooks/useAuthContext';
import { ISlot } from '../../../1_shared/config/interfaces/ISlot';
import { RoutePath } from '../../../1_shared/config/routes';
import { ISpecialistPersonalCardProps } from '../interfaces/ISpecialistPersonalCardProps';

/*
 * Компонент карточки с черным фоном для страницы специалиста
 */
const SpecialistPersonBlackCard = ({
  pageType,
  spec,
}: ISpecialistPersonalCardProps): ReactElement => {
  const { user } = useAuthContext();
  const navigate = useNavigate();
  const subscriptions = JSON.parse(
    localStorage.getItem('subscriptions') || '[]',
  );

  const onClick = (data?: ISlot) => {
    // @ts-ignore
    ym(97788822, 'reachGoal', 'booking', {
      isAuthorize: !!user,
      userId: user?.id ?? null,
    });

    navigate(RoutePath.ORDER, {
      state: { id: spec.id, slot: data || spec.slots[0] },
    });
  };

  const isSubscribed = subscriptions?.includes(spec?.id);

  const specialistImage = spec.mediaContentResponse.length
    ? spec.mediaContentResponse?.[0]
    : spec.mediaContentResponse;

  return (
    <div className={styles.container}>
      <div className={styles.imageContainer}>
        <PreviewImage
          className={styles.wrapperImage}
          media={specialistImage}
          rootClassName={styles.img}
          showPreview
        />
      </div>
      <div className={styles.infoWrapper}>
        <div className={styles.header}>
          <Link className={styles.nameBlock} to={`specialist/${spec.latinId}`}>
            <Typography type="title" className={styles.firstAndLastName}>
              {spec.firstName}
            </Typography>
            <Typography type="title" className={styles.firstAndLastName}>
              {spec.secondName}
            </Typography>
          </Link>
          <div className={styles.wrapperNavigation}>
            <InfoSpecialist dark specialist={spec} isPopover showDuration />
            <SpecialistNavigate
              className={styles.darkWrapperBtns}
              id={spec.latinId}
              specId={spec.id}
              specName={`${spec.firstName} ${spec.secondName}`}
              dark
              slots={spec.slots}
              handleReserve={onClick}
              isSubscribed={isSubscribed}
              pageType={pageType}
            />
          </div>
        </div>
        <SpecialisationInfo specialist={spec} darkMode />
        <Slots
          dark
          slots={spec.slots}
          spec={spec}
          className={styles.wrapperSlot}
          onChange={changeValue => {
            onClick(changeValue);
          }}
          label="ВСЕ СЛОТЫ"
          pageType={pageType}
        />
      </div>
    </div>
  );
};

export default SpecialistPersonBlackCard;
